// removed by extract-text-webpack-plugin
module.exports = {"patientCard":"_2I0bTbdb8Llfy3rmzZNc6A","name":"_1mFM4gDmUy7io6kMyOVRi3","rightAlign":"u__ELUKqr4GBQoZVT70yp"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/PatientCard.scss
// module id = 578
// module chunks = 0